import './class-component-hooks';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from '@/store/index';
import ElementUI from 'element-ui';
import './styles.scss';
import './global.sass';
import 'codemirror/lib/codemirror.css';
import 'katex/dist/katex.min.css';
import 'highlight.js/styles/github.css';

Vue.use(ElementUI);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
